import React, {useState} from 'react';
import {Modal, Button, Icon, Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../../../common/actions';
import {useDispatch, useSelector} from 'react-redux';
import KatashikiesListTable from './katashikiesListTable';
import {getColumns} from './katashikiesListColumns';

import '../../styles.scss';

const {
  fetchVehiclesModelsList,
  cleanVehiclesModelsList,
} = Actions;

const KatashikiesModal = ({handleComboKatashikies, isSelected, disabled}) => {
  const [modalOpened, setModalOpened] = useState(false);
  const loading = useSelector((state) => state.vehiclesModelsList.loading);
  const katashikiesList = useSelector((state) => state.vehiclesModelsList.list);
  const [columns] = useState(getColumns());
  const dispatch = useDispatch();

  const openComboKatashikiesModal = (e) => {
    e.preventDefault();
    dispatch(fetchVehiclesModelsList());
    setModalOpened(true);
  };

  const closeComboKatashikiesModal = (e) => {
    e.preventDefault();
    dispatch(cleanVehiclesModelsList());
    setModalOpened(false);
  };

  const renderLoader = () => {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' content='Ejecutando' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  };

  return (
    <Modal
      trigger={
        <Button primary content='Añadir Katashikies' className='ico-center' disabled={disabled}
          icon={<Icon name='car' size='big'/>} />
      }
      open={modalOpened}
      onOpen={(e) => openComboKatashikiesModal(e)}
      onClose={(e) => closeComboKatashikiesModal(e)}
      size='large'
      closeOnEscape={true}
      closeOnDimmerClick={true}
      header={
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>Búsqueda de Katashikies</h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => closeComboKatashikiesModal(e)} />
        </div>
      }
      content={
        <div className='content'>
          {loading ? renderLoader() :
            <KatashikiesListTable tableColumns={columns} tableData={katashikiesList} disabled={disabled}
              handleComboKatashikies={handleComboKatashikies.bind(this)} isSelected={isSelected.bind(this)} />}
        </div>
      }
    />
  );
};

export default KatashikiesModal;
